import ContentPage from "../components/page/ContentPage";
import type { Route } from "./+types/piscinas-naturais";

export function meta({}: Route.MetaArgs) {
  return [
    { title: "Piscinas Naturais - Maragogi ao Mar" },
    { name: "description", content: "Piscinas Naturais, Passeio de Buggy e Jet Ski em Maragogi" },
  ];
}

export default function PiscinasNaturais() {
  return (
    <ContentPage title="Piscinas Naturais">
      <p>
        As Piscinas Naturais se formam na maré baixa próximo a barreira de coral, que ficam a aproximadamente 4km da costa, na Praia de Ponta de Mangue.<br/><br/>
      </p>
      <img src="/03.jpeg" alt="Piscinas Naturais de Maragogi" />
      <p>
        <br/>
        O passeio dura cerca de 2h30, está incluso a parada nas Piscinas Naturais e Croa da Bruna, 
        é importante ressaltar que o passeio só é feito com a maré baixa e em um horário específico a ser informado na reserva. <br/><br/>
      </p>
      <img src="/01.jpeg" alt="Piscinas Naturais de Maragogi" />
      <p>
        <br/>
        Além do passeio as piscinas naturais, temos como opcionais: Mergulho com Cilindro, Mergulho com Snorkel e Fotos subaquáticas com Peixinhos<br/><br/>
      </p>
      <img src="/05.jpeg" alt="Piscinas Naturais de Maragogi" />
      <p>
        <br/>
        O nosso passeio é feito com Lanchas para até 06 pessoas, isso garante mais conforto e privacidade para nossos clientes. 
        Todas as lanchas possuem alvarás para visitação as piscinas e passeio pela orla, nossos marinheiros são habilitados e capacitados.<br/>
        <br/>
      </p>
      <img src="/06.jpeg" alt="Piscinas Naturais de Maragogi" />
      <p>
        <br/>
        <b>Política de Cancelamento</b>
        <br/><br/>
        Até 07 dias antes: Reembolso de 100%<br/>
        Entre 06 e 03 dias: Reembolso de 50%<br/>
        Menos de 72 horas: Sem reembolso<br/>
        <br/><br/>
      </p>
    </ContentPage>
  )
}